module.exports = __webpack_public_path__ + "img/slogan_illustration.8cb35ddc.svg";